import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { adjustUserBalance } from "../../store/user/action";
import { permissionError } from "../../util/Alert";

const AdjustBalanceDialog = ({ open, onClose, user, balanceType }) => {
  const dispatch = useDispatch();
  const hasPermission = useSelector((state) => state.admin.admin.flag);
  const [adjustment, setAdjustment] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const isDiamond = balanceType === "diamond";
  const label = isDiamond ? "Diamond" : "VCoin";
  const currentBalance = isDiamond ? user?.diamond : user?.rCoin;

  useEffect(() => {
    if (!open) {
      setAdjustment("");
      setError("");
      setSubmitting(false);
    }
  }, [open]);

  const validate = (value) => {
    if (!value.toString().trim()) return "Adjustment is required.";
    const parsed = Number(value);
    if (!Number.isSafeInteger(parsed) || parsed === 0) {
      return "Enter a non-zero whole number.";
    }
    if (parsed < 0 && Math.abs(parsed) > Number(currentBalance || 0)) {
      return `${label} balance cannot be reduced below zero.`;
    }
    return "";
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationError = validate(adjustment);
    if (validationError) return setError(validationError);
    if (!hasPermission) return permissionError();

    setSubmitting(true);
    const result = await dispatch(adjustUserBalance(user, balanceType, Number(adjustment)));
    setSubmitting(false);
    if (result) onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} disableBackdropClick disableEscapeKeyDown fullWidth maxWidth="xs">
      <DialogTitle>
        <span className="text-danger font-weight-bold h4">Adjust {label}</span>
      </DialogTitle>
      <IconButton style={{ position: "absolute", right: 0 }}>
        <Tooltip title="Close">
          <Cancel className="text-danger" onClick={onClose} />
        </Tooltip>
      </IconButton>
      <DialogContent>
        <form onSubmit={handleSubmit} className="modal-body pt-1 px-1 pb-3">
          <div className="form-group">
            <label className="mb-2 text-gray">Current balance</label>
            <div className="h4 text-white">{Number(currentBalance || 0).toLocaleString()}</div>
          </div>
          <div className="form-group mt-4">
            <label className="mb-2 text-gray">Signed adjustment</label>
            <input
              type="number"
              step="1"
              className="form-control"
              placeholder="Example: 500 or -500"
              value={adjustment}
              onChange={(event) => {
                setAdjustment(event.target.value);
                setError(validate(event.target.value));
              }}
              autoFocus
            />
            <small className="text-gray">Use a positive number to add or a negative number to deduct.</small>
            {error && <div className="text-red mt-1">{error}</div>}
          </div>
          <div className="mt-5">
            <button type="button" className="btn btn-outline-info ml-2 btn-round float__right icon_margin" onClick={onClose} disabled={submitting}>
              Close
            </button>
            <button type="submit" className="btn btn-round float__right btn-danger" disabled={submitting || Boolean(error) || !adjustment.toString().trim()}>
              {submitting ? "Adjusting..." : `Adjust ${label}`}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AdjustBalanceDialog;
